import Loading from 'components/Loading'
import { StripeProvider } from 'contexts/StripeContext'
import { useStore } from 'state/store'
import Billing from 'views/Billing'

const BillingContainer = () => {
  const workspaceId = useStore(state => state.workspace.id) as string

  if (!workspaceId) return <Loading />

  return (
    <StripeProvider>
      <Billing workspaceId={workspaceId} />
    </StripeProvider>
  )
}

export default BillingContainer
